<template>
  <div class="ele-page">
    <!-- 分页 -->
    <el-pagination
      v-bind="$attrs"
      v-on="$listeners"
      :style="{ 'text-align': position }"
      :page-sizes="pageSizes"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      @prev-click="handleCurrentChange"
      @next-click="handleCurrentChange"
      :current-page.sync="pages.currentPage"
      :page-size.sync="pages.pageSize"
      :total="pages.total"
      layout="total, prev, pager, next, jumper"
    ></el-pagination>
  </div>
</template>

<script>
  export default {
    name: "ElePage",
    props: {
      pager: {
        // 分页信息
        type: Object,
        default: function () {
          return {
            currentPage: 1,
            pageSize: 10,
            total: 0,
          };
        },
      },
      // 位置
      position: {
        type: String,
        default: "right",
      },
      // 页数的数组
      pageSizes: {
        type: Array,
        default: () => [5, 10, 20, 50],
      },
    },
    computed: {
      pages() {
        return this.pager
      }
    },
    methods: {
      // size发生变化时，并发送自定义事件
      handleSizeChange(val) {
        this.$emit("paginationSize", val);
      },
      // currentPage发生变化时，发送自定义事件
      handleCurrentChange(val) {
        this.$emit("paginationCurrent", val);
      },
    },
  };
</script>

<style lang="less" scoped>
  @import "./config/index";

  .ele-page {
    margin: 10px 0;
    color: #fff;
    z-index: 9999;
    /*display: flex;*/

    /deep/ .el-pagination {
      color: #fff;
      line-height: 34px;

      .el-pagination__total,
      .el-pagination__sizes,
      .el-pagination__jump {
        color: #fff;
      }

      .el-pagination__total {
        line-height: 36px;
      }

      button,
      li {
        width: 34px;
        height: 32px;
        background: rgba(9, 23, 44, 0.15);
        border-radius: 4px;
        border: 1px solid #4d5763;
        font-weight: 400;

        &:hover {
          color: #5ED6FF;
        }
      }

      .btn-prev,
      .btn-next {
        //.flex-center();
        /*display: inline-flex;*/
        /*justify-content: center;*/
        padding: 0;
        color: #fff;
      }

      .el-pager {
        margin: 0 8px;

        li {
          margin: 0 8px;
          width: auto;
          &.active {
            color: #5ED6FF;
          }

          &.el-icon {
            color: #fff;
          }
        }
      }

      .el-pagination__jump {
        /*display: inline-flex;*/
        /*align-items: center;*/

        .el-input {
          width: 58px;
          margin: 0 8px;
        }

        input {
          width: 48px;
          margin: 0 8px;
        }
      }

      input {
        height: 34px;
        background: rgba(9, 23, 44, 0.15);
        border-radius: 4px;
        border: 1px solid #4d5763;
        color: #fff;
      }
    }

    /deep/ .el-pagination .el-select .el-input {
      width: 120px;
    }
  }
</style>

<docs>
  ```vue
  <template>
    <div>
      <!-- 定制 -->
      <ElementPagination
        ref="ElementPagination"
        :pager="pager"
        :position="'right'"
        background
        @paginationSize="handleSizeChange"
        @paginationCurrent="handleCurrentChange"
      />
    </div>
  </template>

  <script>
    export default {
      data() {
        return {
          // 分页数据
          pager: {
            pageSize: 5, // 每页数据量
            currentPage: 1, // 分页  当前页
            // 请求数据的总数
            total: 100, //列表总数
          },
        };
      },
      methods: {
        // 分页页数
        handleSizeChange(val) {
          // 获取方法一：handleSizeChange(val){}
          this.pager.currentPage = 1;
          console.log(this.pager);

          // 获取方法二：handleSizeChange(){}
          let {currentPage, pageSize, total} = this.$refs.ElementPagination.pager;
          console.log(currentPage, pageSize, total);
        },
        // 目标页码
        handleCurrentChange(val) {
          // 获取方法一：handleSizeChange(val){}
          this.pager.currentPage = val;
          console.log(this.pager);

          // 获取方法二：handleSizeChange(){}
          let {currentPage, pageSize, total} = this.$refs.ElementPagination.pager;
          console.log(currentPage, pageSize, total);
        },
      },
    };
  </script>
  ```
</docs>